module.exports = __webpack_public_path__ + "static/media/ATCLogo_mobile.e530b165.png";